import React, { ComponentProps, FC } from "react";
import { IBaseTextContent } from "@/interfaces";
import { cn } from "@/lib";

const CoreServicesSectionHeader: FC<
  ComponentProps<"div"> &
    IBaseTextContent & {
      titleClassName?: string;
      descriptionClassName?: string;
    }
> = ({
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
}) => {
  return (
    <div
      id="core-services-landing"
      className={cn(
        "mx-auto mb-14 w-full max-w-[800px] px-4 pt-4 text-center md:pb-3 lg:mb-24 lg:max-w-full",
        className,
      )}
    >
      <h2
        className={cn(
          "text-primary-main mb-3 text-xs font-bold sm:text-sm lg:text-lg",
          titleClassName,
        )}
      >
        {title}
      </h2>
      <p
        className={cn(
          "text-micro text-justify font-normal sm:text-xs lg:text-base",
          descriptionClassName,
        )}
      >
        {description}
      </p>
    </div>
  );
};

export default CoreServicesSectionHeader;
